export default __webpack_public_path__ + "static/media/expand-icon.2bf0938e.svg";